import { Link } from "react-router-dom";
import { Reveal } from "@/components/Motion";
import { HeroSlider } from "@/components/HeroSlider";
import { Phases } from "@/components/Phases";
import { Domains } from "@/components/Domains";
import { scrollToTarget } from "@/components/SmoothScroll";
import { ArrowDown } from "lucide-react";

const muted = { color: "var(--kh-text-muted)" };

export const ApplyBanner = () => (
  <section className="my-24 mx-6 sm:mx-10 lg:mx-14" data-testid="apply-banner">
    <Reveal className="max-w-7xl mx-auto">
      <div className="p-10 sm:p-14 lg:p-20 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8" style={{ background: "var(--kh-surface-2)", border: "1px solid var(--kh-border)", borderRadius: "var(--kh-radius)" }}>
        <div className="max-w-2xl">
          <div className="kh-eyebrow mb-4">Courses run year-round</div>
          <h2 className="kh-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">Train in a method built for what comes after survival.</h2>
          <p className="mt-5 text-base leading-relaxed" style={muted}>Applications are open to qualified clinicians with at least two years of post-registration trauma practice.</p>
        </div>
        <Link to="/apply" className="kh-btn-primary" data-testid="banner-apply-button">Begin application <span className="kh-arrow" aria-hidden="true">→</span></Link>
      </div>
    </Reveal>
  </section>
);

export default function TherapyPage() {
  return (
    <main data-testid="therapy-page">
      <HeroSlider only="method" action={
        <button type="button" className="kh-btn-primary" onClick={() => scrollToTarget(document.querySelector("[data-testid=phases-section]"))} data-testid="hero-learn-more-button">
          Learn More <ArrowDown size={16} className="kh-arrow-down" aria-hidden="true" />
        </button>
      } />
      <Phases />
      <Domains />
      <ApplyBanner />
    </main>
  );
}
